import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const generateShortcutsCallable = httpsCallable(functions, 'generateWorkspaceShortcuts');

const generateShortcuts = async (content_id, isReprocess = false) => {
  const payload = {
    contentId: `workspace-${content_id}`,
    isSCTimestampsEnabled: true,
    isSCTitlesEnabled: false,
    isSCTagsEnabled: false,
    isReprocess,
  };

  try {
    const result = await generateShortcutsCallable(payload);
    return result.data;
  } catch (error) {
    throw error;
  }
};

export { generateShortcuts };
